import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "../data/site";

// WhatsApp brand SVG (no emoji)
const WaIcon = ({ size = 26 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden="true">
    <path
      fill="currentColor"
      d="M19.11 17.67c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.23-.65.08-.3-.15-1.27-.47-2.42-1.49-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.93-2.23-.24-.58-.49-.5-.68-.51l-.58-.01c-.2 0-.53.08-.81.38-.28.3-1.06 1.04-1.06 2.53s1.09 2.94 1.24 3.14c.15.2 2.14 3.27 5.19 4.59.73.31 1.3.5 1.74.64.73.23 1.4.2 1.93.12.59-.09 1.78-.73 2.03-1.43.25-.7.25-1.3.18-1.43-.08-.13-.28-.2-.58-.35zM16.02 5.33c-5.9 0-10.69 4.79-10.69 10.69 0 1.89.5 3.74 1.45 5.36L5 27l5.78-1.51a10.7 10.7 0 0 0 5.24 1.36h.01c5.9 0 10.69-4.79 10.69-10.69 0-2.86-1.11-5.55-3.13-7.57a10.66 10.66 0 0 0-7.57-3.26zm0 19.45h-.01a8.78 8.78 0 0 1-4.48-1.23l-.32-.19-3.43.9.92-3.34-.21-.34a8.78 8.78 0 0 1-1.34-4.66c0-4.85 3.95-8.79 8.8-8.79 2.35 0 4.56.92 6.22 2.58a8.74 8.74 0 0 1 2.57 6.22c0 4.85-3.95 8.79-8.79 8.79z"
    />
  </svg>
);

export default function WhatsappFab() {
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(t);
  }, []);

  if (location.pathname.startsWith("/admin")) return null;

  const phone = (SITE.whatsapp || SITE.phone || "").replace(/\D+/g, "");
  const message = encodeURIComponent(
    `Hi ${SITE.brand}, I'd like to inquire about your biscuit dies / rollers. Could you help me with a quote?`
  );
  const href = phone ? `https://wa.me/${phone}?text=${message}` : "#";

  return (
    <a
      data-testid="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className={`fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      <div className="group flex items-center gap-3 bg-[#25D366] text-white pr-5 pl-3 py-3 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.4)] hover:shadow-[0_14px_40px_-12px_rgba(37,211,102,0.7)] transition-all">
        <span className="grid place-items-center w-10 h-10 rounded-full bg-white text-[#25D366]">
          <WaIcon size={22} />
        </span>
        <div className="leading-tight">
          <div className="font-mono-accent text-[10px] tracking-[0.2em] uppercase opacity-90">Live · Mon–Sat</div>
          <div className="font-display text-base">Chat on WhatsApp</div>
        </div>
        <span className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
        </span>
      </div>
    </a>
  );
}
